export default "__VITE_ASSET__miVNmcQ9__"